import type { Terminal } from '../terminal';
import type { GameState, AllocationPlan } from '../../types/game-state';
import { getWeaponCount } from '../../engine/arsenal';

async function runAllocation(terminal: Terminal, state: GameState): Promise<AllocationPlan> {
  const playerArsenal = state.playerSide === 'US' ? state.usArsenal : state.ussrArsenal;
  const counts = getWeaponCount(playerArsenal);

  await terminal.println('');
  await terminal.println('════════════════════════════════════════════════════════════════');
  await terminal.println(`  WEAPONS ALLOCATION  --  ROUND ${state.currentRound}`, { cssClass: 'bright' });
  await terminal.println('════════════════════════════════════════════════════════════════');
  await terminal.println('');
  await terminal.println(`  READY WEAPONS: ${counts.ready} DELIVERY SYSTEMS / ${counts.warheads} WARHEADS`);
  await terminal.println('');
  await terminal.println('  STRATEGIC POSTURE OPTIONS:');
  await terminal.println('');
  await terminal.println('    1.  FULL STRIKE     -- COMMIT 100% OF READY FORCES');
  await terminal.println('    2.  MAJOR STRIKE    -- COMMIT 70%, HOLD 30% RESERVE');
  await terminal.println('    3.  LIMITED STRIKE   -- COMMIT 40%, HOLD 60% RESERVE');
  await terminal.println('    4.  SURGICAL STRIKE  -- COMMIT 20%, HOLD 80% RESERVE');
  await terminal.println('');

  while (true) {
    const input = await terminal.waitForInput('SELECT POSTURE: ');

    switch (input.trim()) {
      case '1':
        await terminal.println('\nFULL STRIKE AUTHORIZED. ALL WEAPONS COMMITTED.', { cssClass: 'danger' });
        await terminal.pause(500);
        return { offensivePercent: 100, reservePercent: 0 };
      case '2':
        await terminal.println('\nMAJOR STRIKE AUTHORIZED. 30% HELD IN RESERVE.', { cssClass: 'warning' });
        await terminal.pause(500);
        return { offensivePercent: 70, reservePercent: 30 };
      case '3':
        await terminal.println('\nLIMITED STRIKE AUTHORIZED. 60% HELD IN RESERVE.', { cssClass: 'bright' });
        await terminal.pause(500);
        return { offensivePercent: 40, reservePercent: 60 };
      case '4':
        await terminal.println('\nSURGICAL STRIKE AUTHORIZED. 80% HELD IN RESERVE.', { cssClass: 'bright' });
        await terminal.pause(500);
        return { offensivePercent: 20, reservePercent: 80 };
      default:
        await terminal.println('INVALID OPTION. SELECT 1-4.', { cssClass: 'warning' });
    }
  }
}

export { runAllocation };
